/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Component } from 'react'
import { Container } from 'flux/utils'
import { withRouter } from 'react-router'
import SettingInfoView from '../../view/pages/room/SettingInfoView'
import RoomStore from '../../store/room/RoomStore'
import SettingInfoStore from '../../store/room/SettingInfoStore'
import RoomAction from '../../action/room'

class SettingInfoContainer extends Component {
  static getStores() {
    return [SettingInfoStore, RoomStore]
  }

  static calculateState(prevState, props) {
    return {
      settingInfo: SettingInfoStore.getState(),
      room: RoomStore.getState(),
      ...props
    }
  }

  componentDidMount() {
    const id = this.state.match.params.id

    // id がない場合は新規作成
    if (id) RoomAction.fetchOne(id)
  }

  render() {
    return SettingInfoView(this.state)
  }
}

export default withRouter(Container.create(SettingInfoContainer, { withProps: true }))
